<hmf-drawer
  #drawer
	id="drawer-product-recommendations"
	[closableSide]="'right'"
  [focus]="false"
	[interactability]="false"
	[isCloseButtonSticky]="true"
	[headerText]="headerText"
	[mobilePeek]="isMobile"
	[className]="isMobile ? 'drawer-product-recommendations-mobile' : 'drawer-product-recommendations-desktop'"
	[closable]="true"
  [direction]="isMobile ? 'bottom' : 'right'"
	(closed)="closeDrawer()"
>
  <div class="drawer-product-recommendations">
    <div class="drawer-product-recommendations-container">
      <product-recommendations-components-product-recommendations
        *ngIf="showProductRecommendations"
        schemes="schemes"
        [cardSize]="isMobile ? 'small' : 'medium'"
        [filterBy]="filterBy"
        [showQVButtons]="showQVButtons"
        [showVerticalLegacy]="showVerticalLegacy"
        [showVertical]="!showVerticalLegacy"
        [showSkeletonLoading]="true"
        (quickViewClick)="openQuickviewPanel($event)"
      />
    </div>
  </div>
</hmf-drawer>